module.exports = __webpack_public_path__ + "static/savinglives_card_img1@2x-52b174eaf2ea72c30edd6ce752b001a4.jpg";